// Bilingual copy (VN-first). Expanded as sections are built.
export const copy: Record<string, { vi: string; en: string }> = {
  'nav.carbon': { vi: 'Bản đồ carbon', en: 'Carbon map' },
  'nav.problem': { vi: 'Vấn đề', en: 'Problem' },
  'nav.solution': { vi: 'Giải pháp', en: 'Solution' },
  'nav.how': { vi: 'Quy trình', en: 'How it works' },
  'nav.products': { vi: 'Sản phẩm', en: 'Products' },
  'nav.news': { vi: 'Tin tức', en: 'News' },
  'nav.cta': { vi: 'Vào hệ thống', en: 'Launch console' },

  'hero.kicker': { vi: 'VỆ TINH · TRUY XUẤT · TUÂN THỦ', en: 'SATELLITE · TRACE · COMPLIANCE' },
  'hero.h1a': { vi: 'Mỗi lô cà phê,', en: 'Every coffee lot,' },
  'hero.h1b': { vi: 'một bằng chứng không thể chối cãi.', en: 'evidence you can defend.' },
  'hero.sub': {
    vi: 'ARGO biến vùng trồng cà phê Việt Nam thành dữ liệu đạt chuẩn EUDR — mỗi lô một Lot Passport kiểm chứng được, sẵn sàng cho nhà nhập khẩu EU.',
    en: 'ARGO turns Vietnamese coffee plots into EUDR-ready evidence — one verifiable Lot Passport per lot, ready for EU importers.',
  },
  'hero.cta_app': { vi: 'Vào hệ thống ARGO', en: 'Launch ARGO console' },
  'hero.cta_sol': { vi: 'Xem giải pháp', en: 'See how it works' },
  'hero.export': { vi: 'Xuất Lot Passport', en: 'Export Lot Passport' },
  'hero.metric_area': { vi: 'Diện tích', en: 'Area' },
  'hero.metric_loss': { vi: 'Mất rừng sau 2020', en: 'Forest loss · post-2020' },
  'hero.metric_conf': { vi: 'Độ tin cậy', en: 'Confidence' },
  'hero.plot_label': { vi: 'Thửa CMG-04 · Cư M’gar, Đắk Lắk', en: 'Plot CMG-04 · Cư M’gar, Đắk Lắk' },

  'verdict.pass': { vi: 'Đạt', en: 'Pass' },
  'verdict.review': { vi: 'Cần rà soát', en: 'Review' },
  'verdict.fail': { vi: 'Không đạt', en: 'Fail' },

  'common.live': { vi: 'TRỰC TIẾP', en: 'LIVE' },
  'app.placeholder': { vi: 'Bảng điều khiển ARGO — đang dựng', en: 'ARGO console — under construction' },
}
